import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  buyerName: {
    fontSize: '14px',
    fontWeight: 400,
    color: theme.palette.labraText.tertiary,
  },
  subRowText: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.palette.labraText.description,
  },
  textCellWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.75),
  },
  noResultHeaderContainer: {
    paddingLeft: theme.spacing(2),
    marginTop: theme.spacing(4),
  },
  noResultHeading: {
    color: theme.palette.textField.main,
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  noResultSubHeading: {
    marginTop: theme.spacing(2),
    color: theme.palette.textField.main,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  resultHeadingContainer: {
    width: theme.spacing(27.875),
    height: theme.spacing(2.5),
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  resultHeading: {
    color: theme.palette.textField.main,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
}))
